import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { AddSurveyConfigComponent } from './../addsurveyconfig/add-surveyconfig.component';

import { SurveyConfiguration } from '../../../shared/models/survey/survey-config.model';

import { SurveyManagementService } from './../survey-management.service';

@Component({
  selector: 'surveyconfig-list',
  templateUrl: './surveyconfig-list.component.html',
  styleUrls: ['./surveyconfig-list.component.css']
})

/**
 * Component for display the survey configuration list.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
export class SurveyConfigListComponent implements OnInit {
  add = 'Add';
  edit = 'Edit';
  dialogRef: MdDialogRef<any>;
  surveyConfigs: SurveyConfiguration[];
  selectedConfiguration: SurveyConfiguration;
  surveyConfigsLoaded = false;

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private surveyManagementService: SurveyManagementService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) { }

  ngOnInit() {
    this.getSurveyConfigList();
  }

  openAddSurveyConfigDialog(action: string) {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(AddSurveyConfigComponent, config);
    this.dialogRef.componentInstance.selectedConfiguration = this.selectedConfiguration;
    this.dialogRef.componentInstance.action = action;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.updateSurveyConfigs(action, result);
      }
      this.selectedConfiguration = null;
    });
  }

  updateSurveyConfigs(action: string, result: SurveyConfiguration) {
    if (action === 'Edit') {
      this.surveyConfigs
        .splice(this.surveyConfigs.indexOf(this.selectedConfiguration), 1);
    }
    this.surveyConfigs.unshift(result);
  }

  getSurveyConfigList() {
    this.surveyManagementService.getSurveyConfigs()
      .subscribe(response => {
        this.surveyConfigs = response;
        this.surveyConfigsLoaded = true;
      });
  }

  editSurveyConfig(value: SurveyConfiguration): void {
    this.selectedConfiguration = value;
    this.openAddSurveyConfigDialog(this.edit);
  }

  deleteSurveyConfig(surveyConfig: SurveyConfiguration): void {
    const surveyConfigModel = new SurveyConfiguration();
    surveyConfigModel.id = surveyConfig.id;
    this.surveyManagementService.deleteSurveyConfig(surveyConfigModel)
      .subscribe(response => {
        if (response.flagResult) {
          this.surveyConfigs.splice(this.surveyConfigs.indexOf(surveyConfig), 1);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.SURVEY_MANAGEMENT,
          TrackingConstants.DELETE_SURVEY_CONFIG,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response);
      }, err => {
        this.trackingService
          .emitEvent(
          TrackingConstants.SURVEY_MANAGEMENT,
          TrackingConstants.DELETE_SURVEY_CONFIG,
          TrackingConstants.FAILURE, 0);
        this.callSnackBarService(err);
      });
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.DELETE_SURVEY_CONFIG_SUCCESS,
      MessageService.SURVEY_CONFIG_FAILURE);
  }

  updateSelectedSurveyConfig(updatedSurveyConfig: SurveyConfiguration): void {

  }

  deleteSurveyConfigFromSurveyConfigList(surveyConfigId: string): void {

  }
}



// WEBPACK FOOTER //
// ./src/app/admin/survey/surveyconfiglist/surveyconfig-list.component.ts